<div class="trinka_cloud_wrap">
    <div id="particles-js"></div>

    <section class="mainTopBanner">
        <div class="container">
            <div class="row">
                <div class="col-lg-12">
                    <div class="topBannerWrapper">
                        <div class="top-banner-left">
                            <h1>学術研究機関向けTrinka</h1>
                            <h2>学術英語のライティングをもっと簡単に</h2>
                                <p>学術英語に特化した高度なライティング・アシスタントが、学術的な英文ライティングの慣例に準拠た英文にして、論文出版の可能性を高めます。
                                </p>
                                <div class="btn-group">
                                    <button style="margin: 0; padding: 0;" id="salesContactButtons" data-toggle="modal"
                                    data-target="#EnterPriseContactPopup" class="filled-btn" type="submit">お問い合わせ</button>
                                    <a href="https://calendly.com/trinkaai/meet" target="_blank"  id="autoEditGetStart" class="outline-btn">デモを予約する</a>

                                 </div>
                        </div>
                        <div class="top-banner-right">
                            <img src="../../../assets/images/academic.png" alt="学術研究機関向けTrinka - 文法 チェック" class="img-fluid md50">
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>

    <section class="section-pd trinka-key-features">
        <div class="trinka_container">
            <div class="row justify-content-center">
                <div class="col-md-10 col-lg-8">
                    <div class="trinka-title mb-0 text-center">
                        <h2>こんなお客様におすすめ</h2>
                        <div class="HeadingSubLine1 justify-content-center"><span></span><span></span><span></span></div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-12">
                    <div class="gt-features three-coloum">
                        <span class="hr-line d-sm-block d-none"></span>
                        <span class="vr-line l25"></span>
                        <span class="vr-line l50 d-sm-none"></span>
                        <span class="vr-line l75"></span>
                        <div class="gt-wrapper c-card">
                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                <circle cx="10" cy="10" r="10" fill="#763393"/>
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M14.8277 6.67085C15.0574 6.89866 15.0574 7.26801 14.8277 7.49581L8.94536 13.3291C8.71564 13.557 8.34319 13.557 8.11347 13.3291L5.17229 10.4125C4.94257 10.1847 4.94257 9.81533 5.17229 9.58752C5.40201 9.35972 5.77446 9.35972 6.00418 9.58752L8.52941 12.0917L13.9958 6.67085C14.2255 6.44305 14.598 6.44305 14.8277 6.67085Z" fill="white"/>
                            </svg>
                            <h6>大学・学術研究機関
                            </h6>
                        </div>
                        <div class="gt-wrapper c-card">
                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                <circle cx="10" cy="10" r="10" fill="#763393"/>
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M14.8277 6.67085C15.0574 6.89866 15.0574 7.26801 14.8277 7.49581L8.94536 13.3291C8.71564 13.557 8.34319 13.557 8.11347 13.3291L5.17229 10.4125C4.94257 10.1847 4.94257 9.81533 5.17229 9.58752C5.40201 9.35972 5.77446 9.35972 6.00418 9.58752L8.52941 12.0917L13.9958 6.67085C14.2255 6.44305 14.598 6.44305 14.8277 6.67085Z" fill="white"/>
                            </svg>
                            <h6>団体・協会</h6>
                        </div>
                        <div class="gt-wrapper c-card">
                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                <circle cx="10" cy="10" r="10" fill="#763393"/>
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M14.8277 6.67085C15.0574 6.89866 15.0574 7.26801 14.8277 7.49581L8.94536 13.3291C8.71564 13.557 8.34319 13.557 8.11347 13.3291L5.17229 10.4125C4.94257 10.1847 4.94257 9.81533 5.17229 9.58752C5.40201 9.35972 5.77446 9.35972 6.00418 9.58752L8.52941 12.0917L13.9958 6.67085C14.2255 6.44305 14.598 6.44305 14.8277 6.67085Z" fill="white"/>
                            </svg>
                            <h6>研究開発機関</h6>
                        </div>
                        <div class="gt-wrapper c-card">
                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                <circle cx="10" cy="10" r="10" fill="#763393"/>
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M14.8277 6.67085C15.0574 6.89866 15.0574 7.26801 14.8277 7.49581L8.94536 13.3291C8.71564 13.557 8.34319 13.557 8.11347 13.3291L5.17229 10.4125C4.94257 10.1847 4.94257 9.81533 5.17229 9.58752C5.40201 9.35972 5.77446 9.35972 6.00418 9.58752L8.52941 12.0917L13.9958 6.67085C14.2255 6.44305 14.598 6.44305 14.8277 6.67085Z" fill="white"/>
                              </svg>
                            <h6>研究所</h6>
                        </div>
                        <div class="gt-wrapper c-card">
                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                <circle cx="10" cy="10" r="10" fill="#763393"/>
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M14.8277 6.67085C15.0574 6.89866 15.0574 7.26801 14.8277 7.49581L8.94536 13.3291C8.71564 13.557 8.34319 13.557 8.11347 13.3291L5.17229 10.4125C4.94257 10.1847 4.94257 9.81533 5.17229 9.58752C5.40201 9.35972 5.77446 9.35972 6.00418 9.58752L8.52941 12.0917L13.9958 6.67085C14.2255 6.44305 14.598 6.44305 14.8277 6.67085Z" fill="white"/>
                              </svg>
                            <h6>J出版社</h6>
                        </div>
                        <div class="gt-wrapper c-card">
                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                <circle cx="10" cy="10" r="10" fill="#763393"/>
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M14.8277 6.67085C15.0574 6.89866 15.0574 7.26801 14.8277 7.49581L8.94536 13.3291C8.71564 13.557 8.34319 13.557 8.11347 13.3291L5.17229 10.4125C4.94257 10.1847 4.94257 9.81533 5.17229 9.58752C5.40201 9.35972 5.77446 9.35972 6.00418 9.58752L8.52941 12.0917L13.9958 6.67085C14.2255 6.44305 14.598 6.44305 14.8277 6.67085Z" fill="white"/>
                              </svg>
                            <h6>図書館</h6>
                        </div>
                    </div>            
                </div>
            </div>
        </div>
    </section>

    <div class="brandLogo_sections">
        <div class="container">
            <div class="row">
                <div class="col-sm-2">
                    <h2>世界のトップ企業、学術機関もご利用</h2>
                </div>
                <div class="col-sm-10">
                    <div class="cover_wrapper">
                        <div id="client-logos-enterprise" class="owl-carousel">
                            <div class="item">
                                <div class="client-inners">
                                    <img src="../../../assets/images/client_logos/HarvardMedicalSchool.png" alt="harvard medical school - 英文校正" width="180">
                                </div>
                            </div>

                            <div class="item">
                                <div class="client-inners">
                                    <img src="../../../assets/images/client_logos/StanfordUniversity.png" alt="Stanford University - 英文チ ェッカー" width="180">
                                </div>
                            </div>
                            <div class="item">
                                <div class="client-inners">
                                    <img src="../../../assets/images/client_logos/PrincetonUniversity.png" alt="Princeton University - 文法 チェック" width="180">
                                </div>
                            </div>
                            <div class="item">
                                <div class="client-inners">
                                    <img src="../../../assets/images/client_logos/Caltech.png" alt="caltech - 英文校正 ai" width="180">
                                </div>
                            </div>
                            <div class="item">
                                <div class="client-inners">
                                    <img src="../../../assets/images/client_logos/MIT.png" alt="mit - 英文 チェック ai" width="180">
                                </div>
                            </div>
                            <div class="item">
                                <div class="client-inners">
                                    <img src="../../../assets/images/client_logos/Yale.png" alt="yale university - 文法 チェック" width="180">
                                </div>
                            </div>
                            <div class="item">
                                <div class="client-inners">
                                    <img src="../../../assets/images/client_logos/Yonsei_University.png" alt="yonsei university - 英文校正" width="180">
                                </div>
                            </div>
                            <div class="item">
                                <div class="client-inners">
                                    <img src="../../../assets/images/oxford.png" alt="oxford university - 文法 チェック" width="180">
                                </div>
                            </div>
                            <div class="item">
                                <div class="client-inners">
                                    <img src="../../../assets/images/cambridge.png" alt="cambridge unveristy - 英文校正" width="180">
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </div>
   
</div>

<div class="section-pd list-wrapper-style-2">
    <div class="trinka_container">
        <div class="row justify-content-center">
            <div class="col-md-11 col-lg-10">
                <div class="trinka-title mb-0 text-center">
                    <h2>学術研究機関に最適な質の高いライティング支援</h2>
                    <div class="HeadingSubLine1 justify-content-center"><span></span><span></span><span></span></div>
                    <p>膨大なアカデミックライティングから学習し続けるAI搭載の<a [routerLink]="['/grammar-checker']">英文校正</a>ツールTrinkaが、教員や学生による、学術的な水準の高い英文作成をサポートします。</p>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-lg-6 col-md-6">
                <div class="list-wrapper-content-2 list-style-cards flex-title  bt-none">
                    <div class="features_cards_icon">
                        <img src="../../../assets/images/PublicationReadiness.svg" alt="出版適正チェック - 英文校正" srcset="">
                    </div>
                    <div class="features_cards_desc">
                        <h3>出版適正チェック</h3>
                        <p>Trinkaの出版適正チェック機能では、20以上のチェックポイントで文章を査定し迅速な論文出版をサポート。組織の研究ポートフォリオ強化にご活用ください。
                        </p>
                    </div>
                </div>
            </div>
            <div class="col-lg-6 col-md-6">
                <div class="list-wrapper-content-2 list-style-cards flex-title">
                    <div class="features_cards_icon">
                        <img src="../../../assets/images/MedicalSpellCheckicon.svg" alt="学術分野に強い辞書を内蔵 - 文法 チェック" srcset="">
                    </div>
                    <div class="features_cards_desc">
                        <h3>学術分野に強い辞書を内蔵</h3>
                        <p>Trinka内蔵の学術系辞書には、あらゆる分野の用語が収録されています。大学や組織でご利用の辞書データや用語集の追加も可能で、英文での発表、発信を一貫した高い精度に保つことができます。</p>
                    </div>
                </div>

            </div>
            <div class="col-lg-6 col-md-6">
                <div class="list-wrapper-content-2 list-style-cards flex-title  bt-1">
                    <div class="features_cards_icon">
                        <img src="../../../assets/images/StyleGuides.png" alt="スタイルガイド - 英文校正" srcset="">
                    </div>
                    <div class="features_cards_desc">
                        <h3>ビルトインのスタイルガイド／カスタマイズも</h3>
                        <p>Trinkaでは、数回のクリックでAMAやAPAなどのスタイルガイドに合わせた修正ができます。また、標準のスタイルガイド以外のスタイルガイドも設定可能で、チーム全員のライティングスタイル統一も容易になります。
                        </p>
                    </div>
                </div>
            </div>
            <div class="col-lg-6 col-md-6">
                <div class="list-wrapper-content-2 list-style-cards flex-title  bt-1">
                    <div class="features_cards_icon">
                        <img src="../../../assets/images/PublishReadywriting.png" alt="出版に適したレベルの英文 - 文法 チェック" srcset="">
                    </div>
                    <div class="features_cards_desc">
                        <h3>出版に適したレベルの英文</h3>
                        <p>客観性、簡潔さ、フォーマルなトーンなど、学術論文の様式を踏まえ、出版に適した英文への改訂をサポートします。
                        </p>
                    </div>
                </div>
            </div>
            <div class="col-lg-6 col-md-6">
                <div class="list-wrapper-content-2 list-style-cards flex-title  bt-1">
                    <div class="features_cards_icon">
                        <img src="../../../assets/images/ppc_icon.png" width="40" height="40" alt="盗用・剽窃チェック - 英文校正 ai" srcset="">
                    </div>
                    <div class="features_cards_desc">
                        <h3>盗用・剽窃チェック</h3>
                        <p>iThenticate<sup>®</sup> が誇る最先端のテキスト類似性検出アルゴリズムと、最大級の有料出版物データベースによる高品質の盗用・剽窃チェック
                        </p>
                    </div>
                </div>
            </div>
            <div class="col-lg-6 col-md-6">
                <div class="list-wrapper-content-2 list-style-cards flex-title  bt-1">
                    <div class="features_cards_icon">
                        <img src="../../../assets/images/reference-quality.png" width="40" height="40" alt="引用チェック - 英文 チェック ai" srcset="">
                    </div>
                    <div class="features_cards_desc">
                        <h3>引用チェック</h3>
                        <!-- <p>Access management is easy and secure with Trinka’s granular controls for in-house students and distance learners.
                        </p> -->
                        <p>研究の前提や論拠を弱めかねない引用を識別し、論文に信頼性の高い文献を引用できるようにします。</p>
                    </div>
                </div>
            </div>
            <!-- <div class="col-lg-6 col-md-6">
                <div class="list-wrapper-content-2 list-style-cards flex-title  bt-1">
                    <div class="features_cards_icon">
                        <img src="../../../assets/images/journalFinder.svg" width="40" height="40" alt="icon" srcset="">
                    </div>
                    <div class="features_cards_desc">
                        <h3>Journal Finder</h3>
                        <p>Identifies the right journal by comparing the concepts in your paper against millions of publications and publication trends.</p>
                    </div>
                </div>
            </div> -->
            <!-- <div class="col-lg-6 col-md-6">
                <div class="list-wrapper-content-2 list-style-cards flex-title  bt-1">
                    <div class="features_cards_icon">
                        <img src="../../../assets/images/autoFileEdit_icon.svg" width="40" height="40" alt="auto file" srcset="">
                    </div>
                    <div class="features_cards_desc">
                        <h3>Proofread File</h3>
                        <p>Save time with automatic edits on your MS Word documents. Download your edited file with track changes and finalize your document superfast!</p>
                    </div>
                </div>
            </div> -->
            <div class="col-lg-6 col-md-6">
                <div class="list-wrapper-content-2 list-style-cards flex-title  bt-1">
                    <div class="features_cards_icon">
                        <img src="../../../assets/images/ComprehensiveAnalytics.svg" alt="総合的な分析 - 英文チ ェッカー" srcset="">
                    </div>
                    <div class="features_cards_desc">
                        <h3>総合的な分析</h3>
                        <p>Trinkaの利用状況や、各ユーザーの行動を掘り下げて分析することで、効果的な意思決定を行えます。</p>
                    </div>
                </div>
            </div>
            <div class="col-lg-6 col-md-6">
                <div class="list-wrapper-content-2 list-style-cards flex-title  bt-1">
                    <div class="features_cards_icon">
                        <img src="../../../assets/images/EasyUserManagement.svg" alt="ユーザー管理 - 文法 チェック" srcset="">
                    </div>
                    <div class="features_cards_desc">
                        <h3>ユーザー管理</h3>
                        <p>チームアカウントからのメンバー追加や削除も簡単。メンバーの評価や利用制限もリアルタイムに管理できます。
                        </p>
                    </div>
                </div>
            </div>
            <div class="col-lg-6 col-md-6">
                <div class="list-wrapper-content-2 list-style-cards flex-title  bt-1">
                    <div class="features_cards_icon">
                        <img src="../../../assets/images/BulkEditingOperations.svg" alt="一括校正 - ai英文校正" srcset="">
                    </div>
                    <div class="features_cards_desc">
                        <h3>一括校正</h3>
                        <p>MS Word形式のファイルをアップロードすれば、数分で文書全体の校正が完了します。ダウンロードした校正済みファイルでは、修正提案は校閲の変更履歴に残り、確認して「承諾」するかしないかを選択できます。</p>
                    </div>
                </div>
            </div>
            <div class="col-lg-6 col-md-6">
                <div class="list-wrapper-content-2 list-style-cards flex-title  bt-1">
                    <div class="features_cards_icon">
                        <img src="../../../assets/images/DedicatedSupport.svg" alt="手厚いサポート体制 - 英文校正" srcset="">
                    </div>
                    <div class="features_cards_desc">
                        <h3>手厚いサポート体制</h3>
                        <p>専任のスタッフが、お客様のチームにTrinkaを最大限に活用いただけるようサポートします。これには、チームに新たに加わったメンバーに対する細やかなオリエンテーション、マニュアルやビデオウォークスルーが含まれます。
                        </p>
                    </div>
                </div>
            </div>
        </div>

    </div>
</div>

<div class="whiteListing section-pd">
    <div class="trinka_container">
        <div class="row align-items-center" style="margin-bottom: 40px;">
            <div class="col-md-8 col-sm-8">
                <div class="trinka-title mb-0">
                    <h2>IPホワイトリスト</h2>
                    <div class="HeadingSubLine1"><span></span><span></span><span></span></div>
                    <p>IPホワイトリストとは、機密データやシステムを不正アクセスから保護するためのセキュリティ機能です。リソースの閲覧者を制御することで低コストで効果的にセキュリティ強化を行えるため、機密データを扱う組織で活用されています。ホワイトリストはブラックリストの逆で、信頼できる特定のIPアドレスのみにアクセス権を付与する機能です。</p>
                </div>
            </div>
            <div class="col-lg-4 col-sm-4">
                <div class="benefitImage">
                    <img src="../../../assets/images/the-benefit-whitepaper.png" width="200" alt="IPホワイトリスト - 英文校正" class="img-fluid" />
                </div>
            </div>
        </div>
        <div class="row align-items-center">
            <div class="col-lg-8 col-sm-12">
                <div class="trinka-title mb-0">
                    <h3 class="mb-2">メリット</h3>
                    <p>IP ホワイトリストには以下のようなメリットがあります。</p>
                </div>
            </div>
            
        </div>
        <div class="row match-box">
            <div class="col-sm-6 dflex">
                <div class="media">
                    <div class="media-body">
                        <h4>セキュリティの強化 <span><img src="../../../assets/images/icons/cyber-security.png" alt="セキュリティの強化 - 英文チ ェッカー" /></span></h4>
                        <p>信頼できるIPアドレスからのみTrinkaにアクセスできるため、不正アクセスやサイバー攻撃のリスクを軽減できます。</p>
                    </div>
                </div>
            </div>
            <div class="col-sm-6 dflex">
                <div class="media">
                    <div class="media-body">
                        <h4>管理者によるコントロール <span><img src="../../../assets/images/icons/browser.png" alt="管理者によるコントロール - ai英文校正" /></span></h4>
                        <p>管理者がIPアドレスの指定および指定解除をすることで、Trinkaにアクセスできるユーザーを制御できます。</p>
                    </div>
                </div>
            </div>
            <div class="col-sm-6 dflex">
                <div class="media">
                    <div class="media-body">
                        <h4>ダウンタイムの削減 <span><img src="../../../assets/images/icons/clock.png" alt="ダウンタイムの削減 - 英文 チェック ai" /></span></h4>
                        <p>指定IP以外からのアクセスができないため、ユーザーに影響を与える可能性のあるDoS攻撃やアクセス集中のリスクも低減できます。</p>
                    </div>
                </div>
            </div>
            <div class="col-sm-6 dflex">
                <div class="media">
                    <div class="media-body">
                        <h4>コンプライアンスの向上 <span><img src="../../../assets/images/icons/growth.png" alt="コンプライアンスの向上 - 英文校正 ai" /></span></h4>
                        <p>個人情報をはじめ、厳密な管理が組織に求められる情報を保全することができるため、コンプライアンスの向上にもつながります。</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<section class="list-wrapper-style-2">
    <div class="trinka_container">
        <div class="row">
            <div class="col-12">
                <div class="section-usecases section-purple rounded-sm">
                    <div class="row justify-content-center">
                        <div class="col-md-10 col-lg-8">
                            <div class="trinka-title mb-0 text-center">
                                <h2>幅広いシーンで活躍</h2>
                                <div class="HeadingSubLine1 justify-content-center"><span></span><span></span><span></span></div>
                                <p>大学・研究機関向けのソリューションでは、教育・研究に役立つ機能も充実しています。</p>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-lg-6 col-md-6">
                            <div class="list-wrapper-content-2 list-style-cards  bt-none">
                                <h3>学習状況の追跡</h3>
                                <p>それぞれの学生のライティング習熟度をスコア・数値付きで確認できます。</p>
                                <ul>
                                    <li>ライティング品質スコア</li>
                                    <li>文法カテゴリー別のミス数</li>
                                    <li>添削箇所の数</li>
                                    <li> 利用状況の確認</li>

                                </ul>
                            </div>
                        </div>
                        <div class="col-lg-6 col-md-6">
                            <div class="list-wrapper-content-2 list-style-cards">
                                <h3>学生の学術的な英文ライティング能力の向上</h3>
                                <p>Trinkaは修正すべき箇所の問題点を具体的に解説するので、実践を通じたライティングスキルの向上につながります。
                                </p>
                                <ul>
                                    <li>細かいミスの検出</li>
                                    <li>訂正箇所の詳細な解説</li>
                                    <li>ライティング上達のヒントの提供</li>
                                    <li>品質スコアで分かるスキルアップ</li>
                                </ul>
                            </div>
                        </div>
                        <div class="col-lg-6 col-md-6">
                            <div class="list-wrapper-content-2 list-style-cards bt-1">
                                <h3>論文出版のスピードアップ</h3>
                                <p>言葉や体裁の質を高めてデスク・リジェクトを回避すれば、ジャーナルへの論文掲載までの時間短縮も期待できます。</p>
                                <ul>
                                    <li>学術論文としての体裁チェック（論文構成と完全性）</li>
                                    <li>投稿先ジャーナルへの適合性チェック（適切なジャーナルの検索をサポート）</li>
                                    <li>各種スタイルガイドに対応</li>
                                    <li>キーワード提案</li>

                                </ul>
                            </div>
                        </div>
                        <div class="col-lg-6 col-md-6">
                            <div class="list-wrapper-content-2 list-style-cards bt-1">
                                <h3>Wordファイル自動校正</h3>
                                <p>Trinkaにまとめてファイルをアップロードすれば、数分で校正済みファイルを生成します。</p>
                                <ul>
                                    <li>変更の反映や拒否などの編集が可能</li>
                                    <li>ライティング品質のスコアと修正カテゴリー一覧</li>
                                    <li>一括校正によるスピードの向上</li>

                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>


<div class="cloud_key_features section-pd list-wrapper-style-2 tailoredSolutions">
    <div class="trinka_container">
        <div class="row justify-content-center">
            <div class="col-md-11 col-lg-10">
                <div class="trinka-title mb-0 text-center">
                    <h2>お客様のソフトウェアやワークフローへの組み込み</h2>
                    <div class="HeadingSubLine1 justify-content-center"><span></span><span></span><span></span></div>
                    <p>既存のアプリケーションへTrinkaを統合するのも簡単。シームレスにすべての機能を使えて、ライティングの生産性も向上します。</p>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-lg-4 col-md-6">
                <div class="list-wrapper-content-2 list-style-cards bt-none">
                    <h3>JavaScript</h3>

                    <p>
                        JavaScript (JS)の コードをアプリケーションに追加することで、チーム全体がTrinkaを使用できるようになります。
                    </p>
                    <a [routerLink]="['/enterprise']" class="text-link">
                        もっと読む 
                        <i class="fa fa-arrow-right"></i>
                    </a>
                </div>
            </div>
            <div class="col-lg-4 col-md-6">
                <div class="list-wrapper-content-2 list-style-cards">
                    <h3>API</h3>
                    <p>TrinkaのAPIを使えば、自社製品や既存のアプリケーションにTrinkaを簡単に組み込めます。TrinkaのAPIは信頼性や拡張性も抜群です。</p>
                    <a [routerLink]="['/enterprise/grammar-checker-api']" class="text-link">
                        もっと読む 
                        <i class="fa fa-arrow-right"></i>
                    </a>
                </div>
            </div>
            <div class="col-lg-4 col-md-6">
                <div class="list-wrapper-content-2 list-style-cards">
                    <h3>オンプレミス</h3>

                    <p>
                        お客様のローカルまたはクラウドサーバー上でのTrinkaの運用が可能。機密性を最大限確保しながら、効果的なライティングができます。
                    </p>
                    
                    <a [routerLink]="['/enterprise']" class="text-link">
                        もっと読む 
                        <i class="fa fa-arrow-right"></i>
                    </a>
                </div>
            </div>
            <div class="col-lg-4 col-md-6">
                <div class="list-wrapper-content-2 list-style-cards bt-1" style="min-height: 290px;">
                    <h3>Trinka Cloud</h3>
                    <p>
                        安全なウェブベースのアプリケーションで、どこからでもTrinkaの機能を活用できます。
                    </p>
                    <a [routerLink]="['/trinkacloud']" class="text-link">
                        もっと読む 
                        <i class="fa fa-arrow-right"></i>
                    </a>
                </div>
            </div>

            <div class="col-lg-4 col-md-6">
                <div class="list-wrapper-content-2 list-style-cards bt-1" style="min-height: 290px;">
                    <h3>Wordアドイン</h3>
                    <p>
                        MS Word内で提供されるライティング提案で、より的確な文書作成が可能に。
                    </p>
                    <a [routerLink]="['/wordplugin']" class="text-link">
                        もっと読む 
                        <i class="fa fa-arrow-right"></i>
                    </a>
                </div>
            </div>
            <div class="col-lg-4 col-md-6">
                <div class="list-wrapper-content-2 list-style-cards bt-1" style="min-height: 290px;">
                    <h3>ブラウザプラグイン</h3>
                    <p>
                        ブラウザにプラグインを追加すれば、ウェブサイト上での入力もリアルタイムで校正できます。
                    </p>
                    <a [routerLink]="['/browser-plugin']" class="text-link">
                        もっと読む 
                        <i class="fa fa-arrow-right"></i>
                    </a>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="section-pd section-purple">
    <div class="trinka_container">
        <div class="row justify-content-center">
            <div class="col-md-12 col-lg-12">
                <div class="trinka-title text-center">
                    <h2>お客様に合わせた料金プラン</h2>
                    <div class="HeadingSubLine1 justify-content-center"><span></span><span></span><span></span></div>
                    <p>Trinkaはお客様のニーズに合わせ、ユーザー数ベースもしくは使用量ベースの柔軟な料金プランをご提案します。</p>
                    <p>追加料金なしで、ユーザーの変更や、使用の制限や制限解除もリアルタイムで行えます。</p>
                    <p>お客様に作業負荷がかからない形での契約やお支払い方法など、それぞれのご要望に寄り添ったご提案をいたします。</p>
                    <div class="btn-group justify-content-center mt-4">
                        <button style="margin: 0; padding: 0;" id="salesContactButtons" data-toggle="modal"
                        data-target="#EnterPriseContactPopup" class="filled-btn" type="submit">お見積もり</button>
                        <a href="https://calendly.com/trinkaai/meet" target="_blank"  id="autoEditGetStart" class="outline-btn">デモを予約する</a>

                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- <div class="trinka-banner section-pd-sm">
    <div class="trinka_container">
        <div class="row align-items-center justify-content-center">
            <div class="col-md-6 col-lg-6">
                <div class="trinka-title">
                    <h3 class="text-white mb-4">各国のお客様には、現地通貨でのご請求・お支払いにも対応しています。</h3>
                    <p class="text-white">Trinkaでは、日本円（JPY）の他、中国人民元（CNY）、ブラジルレアル（BRL）、トルコリラ（TRY）、大韓民国ウォン（KRW）、インドルピー（INR）、米ドル（USD）、新台湾ドル（TWD）など、各国のお客様に現地の通貨でのご請求を行っています。また、複数のアカウントへのご請求を合算して1つの請求書にまとめることも可能です。</p>
                </div>
                <div class="btn-group">
                    <a [routerLink]="['/local-invoice']" class="white-btn">請求書オプションをチェック</a>
                </div>
            </div>
            <div class="col-md-6 col-lg-6">
                <div class="text-center">
                    <img src="../../../assets/images/local-inovice-element.png" alt="local invoice" class="img-fluid" />
                </div>
            </div>
        </div>  
    </div>
</div> -->

<div class="trinka-banner section-pd-sm">
    <div class="trinka_container">
        <div class="row align-items-center justify-content-center">
            <div class="col-md-6 col-lg-6">
                <div class="trinka-title">
                    <h3 class="text-white mb-4">Trinkaのお支払いは、日本円でのお振込みにも対応</h3>
                    <p class="text-white">銀行振り込みでのご利用料金のお支払いをご希望のお客様には請求書をお送りしています。適格請求書がご入用な場合、お気軽にお申し付けください。日本での販売代理店である株式会社クリムゾンインタラクティブ・ジャパンが、日本円建ての適格請求書を発行いたします。</p>
                </div>
                <div class="btn-group">
                    <a [routerLink]="['/local-invoice']" class="white-btn">請求書の詳細を見る</a>
                </div>
            </div>
            <div class="col-md-6 col-lg-6">
                <div class="text-center mt-sm-30">
                    <img src="../../../assets/images/local-inovice-element.png" alt="現地の請求書 - 文法 チェック" class="img-fluid" />
                </div>
            </div>
        </div>  
    </div>
</div>

<section class="section-pd list-wrapper-style-2">
    <div class="trinka_container">
        <div class="row align-items-center flex-row-reverse">
            <div class="col-md-6">
                <div class="list-wrapper-content-2">
                    <h3>万全のセキュリティ</h3>
                        <p>Trinkaは、データの安全性とプライバシーを最重視した設計になっています。お客様のデータは高度に暗号化され、安全に保管されます。第三者がお客様のデータにアクセスすることはありません。ライティングの提案後に、データを完全に抹消するプランもご用意しています。
                        </p>
                </div>
            </div>
            <div class="col-md-6">
                <div class="list-wrapper-image">
                    <img src="../../../assets/images/safe-secure.png" alt="万全のセキュリティ - 文法 チェック" class="img-fluid">
                </div>
            </div>
        </div>
    </div>
</section>

<section class="section-pd list-wrapper-style-2 pt-0">
    <div class="trinka_container">
        <div class="row align-items-center">
            <div class="col-md-6">
                <div class="list-wrapper-content-2 pr-80">
                    <h3>AIについて</h3>
                        <p>Trinkaは、コミュニケーションの障壁がない未来を願って、言語学者、医学校正者、データサイエンティスト、エンジニアらのチームによって開発されました。</p>
                        <p>Trinkaは、最新の機械学習（ML）と自然言語処理（NLP）の技術を使用して、文法の誤りを特定し、言語の改善案を提案します。医学、ライフサイエンス、生物学、物理科学、工学、人文科学、ビジネス、芸術を含む1300以上の分野の上質な論文や記事を数百万単位で読み込むことでAIが学習し、最適な提案をします。
                        </p>
                </div>
            </div>
            <div class="col-md-6">
                <div class="list-wrapper-image">
                    <img src="../../../assets/images/about-ai.png" alt="AIについて - 英文校正" class="img-fluid">
                </div>
            </div>
        </div>
    </div>
</section>

<div class="trinka-banner section-pd-sm">
    <div class="trinka_container">
        <div class="row justify-content-center">
            <div class="col-md-12 col-lg-10">
                <div class="trinka-title text-center">
                    <h3 class="text-white">Trinkaで英文のライティングスキルを向上させる</h3>
                </div>
                <div class="btn-group justify-content-center">
                    <button id="salesContactButtons" data-toggle="modal" data-target="#EnterPriseContactPopup"
                    class="white-btn" type="submit">お見積もり</button>
                </div>
            </div>
        </div>  
    </div>
</div>

<app-enterprise-modal></app-enterprise-modal>